import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

export default function FullGallery() {
  const navigate = useNavigate();
  
  // Array of 50 images. 
  // We use the '/ui-images/' path which maps directly to your 'public' folder.
  const uiProjects = Array.from({ length: 50 }, (_, i) => ({
    id: i + 1,
    title: `Design Concept ${i + 1}`,
    img: `/ui-images/img${i + 1}.jpeg`, // Path to public folder
  }));

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-[#0B0E11] text-white font-sans">
      
      {/* Navigation */}
      <nav className="p-6 flex justify-between items-center border-b border-white/10 sticky top-0 bg-[#0B0E11]/90 backdrop-blur-md z-50">
        <button 
          onClick={() => navigate("/Portfolio")} 
          className="text-[#00F5A0] font-bold flex items-center gap-2 hover:opacity-70 transition-opacity"
        >
          ← BACK 
        </button>
        <h1 className="text-xl font-bold tracking-tighter text-[#00F5A0]">UI SHOWCASE</h1>
        <div className="w-10"></div>
      </nav>

      {/* Hero */}
      <header className="py-20 px-6 text-center max-w-4xl mx-auto">
        <span className="text-[#00CFFF] uppercase tracking-[0.3em] text-xs font-bold bg-[#00CFFF]/10 px-4 py-1 rounded-full">
          Full Portfolio of UI/UX Design
        </span>
        <h2 className="text-5xl md:text-7xl font-extrabold mt-6 mb-6 leading-tight">
          Crafting Digital <span className="text-[#00F5A0]">Experiences.</span>
        </h2>
        <p className="text-white/60 text-lg max-w-2xl mx-auto">
          Viewing {uiProjects.length} branding and interface concepts.
        </p>
      </header>

      {/* The Gallery Grid */}
      <main className="px-4 sm:px-10 lg:px-20 pb-20">
        <div className="columns-1 sm:columns-2 md:columns-3 lg:columns-4 gap-6 space-y-6">
          {uiProjects.map((project) => (
            <div 
              key={project.id} 
              className="relative group overflow-hidden rounded-2xl bg-white/5 border border-white/10 hover:border-[#00F5A0]/40 transition-all duration-500 break-inside-avoid shadow-2xl"
            >
              {/* Image with Fallback */}
              <img 
                src={project.img} 
                alt={project.title} 
                loading="lazy"
                className="w-full h-auto block transition-all duration-700 group-hover:scale-105"
                onError={(e) => {
                  // If image fails, show a placeholder or hide
                  e.target.src = "https://via.placeholder.com/400x500/111/00F5A0?text=Design+Image";
                }}
              />
              
              {/* Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 p-6 flex flex-col justify-end">
                <p className="text-[#00F5A0] text-[10px] font-bold uppercase tracking-widest">Project {project.id}</p>
                <h3 className="text-lg font-bold text-white tracking-tight">Visual Identity</h3>
              </div>
            </div>
          ))}
        </div>
      </main>

      <footer className="py-20 border-t border-white/5 text-center">
        <button 
          onClick={() => window.scrollTo({top: 0, behavior: 'smooth'})}
          className="text-[#00F5A0] text-sm font-bold border border-[#00F5A0]/30 px-8 py-3 rounded-full hover:bg-[#00F5A0]/10 transition-all"
        >
          SCROLL TO TOP ↑
        </button>
      </footer>
    </div>
  );
}